export const seasonDivisionPoolKeys = {
	pool: (seasonDivisionUuid: string) => ['SEASON_DIVISION_POOL', seasonDivisionUuid] as const
};
